import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import InternationalPrefixesList from "./InternationalPrefixesList";
import InternationalPrefixesCreate from "./InternationalPrefixesCreate";
import { RouteGuard } from "../../guards/RouteGuard";
import { RoleEnum } from "../../types/RoleEnum";
function InternationalPrefixes() {
    var path = useRouteMatch().path;
    var cleanPath = path.replace("/*", "");
    return (React.createElement(Switch, null,
        React.createElement(Route, { exact: true, path: cleanPath, render: function () { return (React.createElement(RouteGuard, { allowedRoles: [RoleEnum.AGENCY_WORKER] },
                React.createElement(InternationalPrefixesList, null))); } }),
        React.createElement(Route, { path: "".concat(cleanPath, "/create"), render: function () { return (React.createElement(RouteGuard, { allowedRoles: [RoleEnum.AGENCY_WORKER] },
                React.createElement(InternationalPrefixesCreate, null))); } })));
}
export default InternationalPrefixes;
